import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading, text" theme="lightest" className="titleBlock-align-left Get-started-in-minutes Explore-other-Adobe-Document-Services-APIs" mdxType="TitleBlock" />
    <h2 {...{
      "id": "get-started-in-minutes"
    }}>{`Get started in minutes`}</h2>
    <p>{`Start with the Free Tier and get 500 free Document Transactions per month.`}</p>
    <TextBlock slots="heading, text, buttons" width="33%" theme="lightest" className='align-left horizontal-align Explore-other-Adobe-Document-Services-APIs' mdxType="TextBlock" />
    <h2 {...{
      "id": "step-1"
    }}>{`Step 1`}</h2>
    <p>{`Obtain free credentials`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://acrobatservices.adobe.com/dc-integration-creation-app-cdn/main.html?api=pdf-electronic-seal-api"
        }}>{`Get started`}</a></li>
    </ul>
    <TextBlock slots="heading, text, buttons" width="33%" theme="lightest" variantsTypePrimary='secondary' variantsTypeSecondary='secondary' variantStyleFill="outline" variantStyleOutline="outline" className='align-left link Explore-other-Adobe-Document-Services-APIs' mdxType="TextBlock" />
    <h2 {...{
      "id": "step-2"
    }}>{`Step 2`}</h2>
    <p>{`Download ready to run samples for Node.js, Java, .Net, and Python`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/adobe/pdfservices-node-sdk-samples"
        }}>{`Node.js`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/adobe/pdfservices-java-sdk-samples"
        }}>{`Java`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/adobe/PDFServices.NET.SDK.Samples"
        }}>{`.Net`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/adobe/pdfservices-python-sdk-samples"
        }}>{`Python`}</a></li>
    </ul>
    <TextBlock slots="heading, text, buttons" width="33%" theme="lightest" className='align-left horizontal-align link extract-stepper-api-reference Explore-other-Adobe-Document-Services-APIs' headerElementType="h2" mdxType="TextBlock" />
    <h2 {...{
      "id": "step-3"
    }}>{`Step 3`}</h2>
    <p>{`Add credentials to your code and experience the power of the API`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/document-services/docs/overview/pdf-electronic-seal-api/"
        }}>{`View docs`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/document-services/docs/apis/#tag/PDF-Electronic-Seal"
        }}>{`View API Reference`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      